import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHeading } from "@/components/Shared";

const FAQS = [
  {
    q: "How is GrowRx different from a marketing agency?",
    a: "We don't do ads, content, SEO, or brand campaigns. GrowRx does one thing: outbound lead generation and appointment setting for IT recruitment firms. Our entire process — targeting, messaging, qualification — is built around how recruitment firms win new clients.",
  },
  {
    q: "Who exactly do you reach out to on our behalf?",
    a: "Companies that hire tech talent and are a strong fit for your services — typically CTOs, VPs of Engineering, Heads of Talent, HR leaders, and founders. We define the ideal client profile with you first, then build prospect lists against it.",
  },
  {
    q: "How soon should we expect meetings?",
    a: "The first weeks go into foundation: targeting, infrastructure, and messaging. Outreach ramps from there, and our goal for every client is a steady 10+ qualified sales meetings per month once the engine is running. Exact timing depends on your market and offer — we'll give you an honest read on your strategy call.",
  },
  {
    q: "Will this hurt our domain or LinkedIn reputation?",
    a: "No. Email campaigns run on properly set up and warmed sending infrastructure, separate from your primary domain. LinkedIn outreach is personalized and volume-conscious — designed to start genuine conversations, not blast your network.",
  },
  {
    q: "What do you need from us to get started?",
    a: "One onboarding conversation to nail down your ideal client profile, your offer, and your best case studies. From there we handle the heavy lifting — you show up to qualified meetings.",
  },
  {
    q: "What happens on the strategy call?",
    a: "A focused 15 minutes: we review how you currently win clients, identify where outbound fits, and outline what a campaign would look like for your firm. You'll leave with a clear plan — whether or not we end up working together.",
  },
];

export const FAQAccordion = () => (
  <section id="faq" className="py-20 sm:py-28 border-t border-[#F0EBF8]" data-testid="faq-section">
    <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-12 gap-12">
      <div className="lg:col-span-5">
        <SectionHeading
          center={false}
          eyebrow="FAQ"
          title="Straight answers, before you even book."
          sub="The questions every recruitment CEO asks us — answered honestly."
        />
      </div>
      <div className="lg:col-span-7">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} className="border-[#F0EBF8]">
              <AccordionTrigger
                data-testid={`faq-trigger-${i + 1}`}
                className="text-left font-display text-lg font-semibold text-[#3B0764] hover:text-violet-700 hover:no-underline py-6 transition-colors duration-300"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-content-${i + 1}`} className="text-base leading-relaxed text-[#6B5CA5] pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);
